module.exports = __webpack_public_path__ + "static/media/Icon_menu_reservation_white.b7d409b9.svg";